import PropTypes from 'prop-types';

const titleTable = ['id', 'imageView', 'name', 'url', 'order', 'translations', 'isEnabled'];
// export const Model = {
//     id: PropTypes.string,
//     name: PropTypes.string,
//     email: PropTypes.string,
//     role: PropTypes.string,
//     password: PropTypes.string,
//     status: PropTypes.bool,
// };
export default { titleTable }
